export enum PaypalMode {
  SANDBOX = 'sandbox',
  PRODUCTION = 'production'
}
